import React from "react";

const SeriesManagementIcon = ({fill}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <g
        id="Group_1439"
        data-name="Group 1439"
        transform="translate(-1127 -96)"
      >
        <g
          id="Rectangle_3560"
          data-name="Rectangle 3560"
          transform="translate(1127 96)"
          fill="none"
          stroke={fill ? fill : "#0051bc"}
          strokeWidth="1"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="15" fill="none" />
        </g>
        <g
          id="Rectangle_3561"
          data-name="Rectangle 3561"
          transform="translate(1130 99)"
          fill={fill ? fill : "#0051bc"}
          stroke={fill ? fill : "#0051bc"}
          strokeWidth="1"
        >
          <rect width="16" height="16" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="15" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default SeriesManagementIcon;
